const poseSequenceNameRx = /^[a-z0-9_ -]{0,60}$/i

const characterDataRules = {
  name: [s => /^[a-z0-9_ -]{0,120}$/.test(s.trim()) ? true : 'Up to 120 alphanumeric characters only'],
  notes: [s => s.length <= 600 ? true : 'Max length exceeded'],
  poseSequenceName: [
    s => s.trim() ? true : 'Name cannot be blank',
    s => s.trim().length <= 60 ? true : 'Cannot be longer than 60 characters',
    s => poseSequenceNameRx.test(s.trim()) ? true : 'Alphanumeric characters only']
}

const validatePoseSequenceName = (name) => {
  name = (name || '').trim()
  for (const v of characterDataRules.poseSequenceName) {
    if (v(name) !== true) {
      return false
    }
  }
  return true
}

export {
  validatePoseSequenceName,
  characterDataRules
}
